const transcribeKeys: { [key: string]: number | string | any } = {
 zero: 0,
 one: 1,
 warn: 1,
 two: 2,
 to: 2,
 true: 2,
 tree: 3,
 three: 3,
 four: 4,
 for: 4,
 five: 5,
 far: 5,
 six: 6,
 sick: 6,
 sicks: 6,
 seven: 7,
 eight: 8,
 hate: 8,
 nine: 9,
 now: 9,
 plus: '+',
 minus: '-',
 times: '*',
 divide: '/',
 by: '/',
 time: '*',
 add: '+',
}

export default transcribeKeys
